import { render, staticRenderFns } from "./select-payment-method.vue?vue&type=template&id=18b1963c&"
import script from "./select-payment-method.vue?vue&type=script&lang=js&"
export * from "./select-payment-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports